<template>
  <v-dialog
    v-model="windowScan"
    width="80%"
    transition="slide-y-reverse-transition"
  >
    <v-card tile>
      <v-toolbar flat dark color="primary">
        <v-toolbar-title v-html="titulo" />
        <v-spacer />
        <v-toolbar-items>
          <v-btn color="" dark icon right @click="closeWindowScan">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-stepper v-model="step" vertical>
          <v-stepper-step
            :complete="step > 0"
            :color="step > 0 ? 'verde' : 'primary'"
            step="0"
          >
            IP Rede
            <small>Informe o IP do DVR/Câmera</small>
          </v-stepper-step>

          <v-stepper-content step="0">
            <v-card class="mb-12">
            <v-col cols="12" md="3">
                <v-text-field
                  v-model="ipDigitado"
                  @keyup="validIpDigitado"
                  label="IP DVR/Câmera"
                  :error-messages="ipDigitadoError"
                  hint="Ex:192.168.1.100 ou 1.1.0.1"
                  maxlength="19"
                  persistent-hint
                />
              </v-col>
              <v-alert
                border="left"
                colored-border
                elevation="1"
                color="color_alert"
                dense
                class="rounded-lg mb-4"
                :style="{
                  border: '1px solid #e0004d',
                  'border-radius': '20px',
                }"
              >
                <div class="py-2">
                  <p class="font-weight-light my-0 text-body-2">
                  Esta é a forma mais rápida para encontrar seus equipamentos, informe o IP do seu equipamento (DVR ou Câmera de segurança). Na configuração do seu equipamento você tem a numeração do IP <br>
                    No menu principal do equipamento -> Info -> Rede -> Endereço IP <br>
                    Caso não consiga essa informação você pode continuar e selecionar sua rede interna para a procura
                  </p>
                </div>
              </v-alert>
            </v-card>
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              @click="nextStep(nextStepIp)"
              >Continue</v-btn
            >
         
               <v-btn color="error" class="ml-2"  @click="closeWindowScan"
              >Cancel</v-btn
            >
          </v-stepper-content>
          <!--- -->
          <v-stepper-step
            :complete="step > 1"
            :color="step > 1 ? 'verde' : 'primary'"
            step="1"
          >
            Rede
            <small>Busca por redes locais</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card class="mb-12">
              <v-data-table
                v-model="redeSelecionada"
                :loading-text="textLoadRede"
                height="200"
                :loading="gridLoadRede"
                :headers="headersRedes"
                :items="listRedes"
                :hide-default-footer="true"
                show-select
                single-select
                fixed-header
              >
              </v-data-table>
              <v-alert
                border="left"
                colored-border
                elevation="1"
                color="color_alert"
                dense
                class="rounded-lg mb-4"
                :style="{
                  border: '1px solid #e0004d',
                  'border-radius': '20px',
                }"
              >
                <div class="py-2">
                  <p class="font-weight-light my-0 text-body-2">
                  Aqui você precisa selecionar a Rede que seus equipamentos estão conectados (DVR/Câmera). Se você não sabe qual IP eles estão, selecione uma rede e faça as próximas etapas. <br>
                  O AlertMe irá procurar seus equipamentos em cada rede que você selecionar, então se não encontrou os equipamentos, você precisa voltar nesta opção e escolher outra rede.
                  </p>
                </div>
              </v-alert>
            </v-card>
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              :disabled="redeSelecionada.length <= 0"
              @click="nextStep(2)"
              >Continue</v-btn
            >
         
            <!-- <v-btn color="error" class="ml-2" @click="nextStep(1)"
              >Voltar</v-btn
            > -->
               <v-btn color="error" class="ml-2"  @click="nextStep(0)"
              >Voltar</v-btn
            >
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 2"
            :color="step > 2 ? 'verde' : 'primary'"
            step="2"
          >
            Configuração
            <small>Porta RTSP</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card class="mb-12">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="cam_port"
                  label="porta"
                  hint="Somente números"
                  maxlength="5"
                  persistent-hint
                />
              </v-col>
              <v-alert
                border="left"
                colored-border
                elevation="1"
                color="color_alert"
                dense
                class="rounded-lg mb-4"
                :style="{
                  border: '1px solid #e0004d',
                  'border-radius': '20px',
                }"
              >
                <div class="py-2">
                  <p class="font-weight-light my-0 mb-4 text-body-2">
                    Porta RTSP é como a sua câmera transmite o vídeo que está
                    sendo filmado. A porta padrão em todos os equipamentos é a
                    <span class="font-weight-bold">554</span>.
                  </p>
                  <p class="font-weight-light my-0 text-body-2">
                    Se foi configurado outra porta na instalação das suas
                    câmeras você precisa questionar o técnico que fez a
                    instalação ou você pode verificar na configuração do seu
                    equipamento
                  </p>
                </div>
              </v-alert>
            </v-card>
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              :disabled="cam_port.length <= 0"
              @click="nextStep(3)"
              >Continue</v-btn
            >
            <v-btn color="error" class="ml-2" @click="nextStep(1)"
              >Voltar</v-btn
            >
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 3"
            :color="step > 3 ? 'verde' : 'primary'"
            step="3"
          >
            Dados de acesso
            <small>Configuração usuário, senha</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="mb-12 px-2 py-2" elevation="2">
              <p class="body-1">
                Informe os possíveis usuários e senhas das câmeras de sua rede
                selecionada
                <strong>{{
                  this.redeSelecionada.length > 0
                    ? this.redeSelecionada[0].mask
                    : ""
                }}</strong>
              </p>
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field v-model="user" label="Usuário" single-line />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field v-model="pwd" label="Senha" single-line />
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn color="primary" class="mt-4" @click.prevent="addUser"
                    >Add</v-btn
                  >
                </v-col>
              </v-row>
              <v-data-table
                height="200"
                :headers="headersLogins"
                :items="listaLogins"
                :hide-default-footer="true"
                fixed-header
              >
                <template v-slot:[`item.actions`]="{ index }">
                  <v-icon
                    color="red"
                    class="mx-1"
                    @click.prevent="removeUser(index)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              :disabled="listaLogins.length <= 0"
              @click="nextStep(4)"
              >Continue</v-btn
            >
            <v-btn color="error" class="ml-2" @click="nextStep(2)"
              >Voltar</v-btn
            >
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 4"
            :color="step > 4 ? 'verde' : 'primary'"
            step="4"
          >
            Configuração Url DVR/Câmera
            <small>Selecione ou preencha o url de seu equipamento</small>
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-card class="mb-12">
              <v-row class="px-2 py-2">
                <v-col cols="12">
                  <v-select
                    :items="listModelos"
                    v-model="selectModeloUrl"
                    item-text="url"
                    item-value="url"
                    label="Modelos DVR/Câmera"
                  >
                    <template v-slot:item="data">
                      {{ data.item.url }}
                      {{
                        data.item.url == listModelos[1].url ? " - (padrão)" : ""
                      }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="urlCamera"
                    :append-outer-icon="
                      openEditUrlCamera ? 'mdi-lock' : 'mdi-pencil'
                    "
                    @click:append-outer="openEditUrlCamera = !openEditUrlCamera"
                    label="Url Câmera"
                    persistent-hint
                    :readonly="!openEditUrlCamera"
                  />
                </v-col>
                <v-col cols="12">
                  <v-alert
                    border="left"
                    colored-border
                    elevation="1"
                    color="color_alert"
                    dense
                    class="rounded-lg mb-4"
                    :style="{
                      border: '1px solid #e0004d',
                      'border-radius': '20px',
                    }"
                  >
                    <div class="py-2">
                      <p class="font-weight-light my-0 text-body-2">
                        Agora você precisa selecionar o modelo dos seus
                        equipamentos para nossa Inteligência Artificial
                        encontrar elas. Já temos vários modelos cadastrados para
                        você apenas selecionar.
                      </p>
                      <p class="font-weight-light my-0 text-body-2">
                        <span class="font-weight-bold">Atenção</span>, você pode
                        tentar utilizar o
                        <span class="font-weight-bold">Modelo (Padrão)</span>, a
                        grande maioria dos equipamentos hoje utilizam este
                        padrão.
                      </p>
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card>
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              :disabled="urlCamera.length <= 10"
              @click="nextStep(5)"
              >Continue</v-btn
            >
            <v-btn color="error" class="ml-2" @click="nextStep(3)"
              >Voltar</v-btn
            >
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 5"
            :color="step > 5 ? 'verde' : 'primary'"
            step="5"
          >
            Configuração câmeras
            <small>Horários,perímetro de monitoramento</small>
          </v-stepper-step>

          <v-stepper-content step="5" class="pr-3">
            <v-progress-linear
              v-show="progressFindCam"
              indeterminate
              color="primary"
              class="mb-10"
              height="20"
            >
              <template>
                Aguarde, enquanto localizamos seu(s) equipamento(s).
              </template>
            </v-progress-linear>
            <div class="col-11 px-0" v-show="error_equipamento.length > 0">
              <v-alert type="error">
                {{ error_equipamento }}
              </v-alert>
            </div>
            <v-row class="d-flex flex-row justify-start mb-5 pt-4 pl-3">
              <v-card
                elevation="2"
                class="mb-2 mr-2 px-2 d-inline-block"
                v-for="(item, index) in listCams"
                :key="index"
                max-width="275"
              >
                <v-card-title v-if="item.cam">
                  <p class="subtitle-2 mt-2 text-truncate">
                    {{ item.cam ? item.cam : "" }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-checkbox
                    v-model="listaCamSelecionada"
                    dense
                    hide-details
                    :value="index"
                  ></v-checkbox>
                  <v-row justify="space-between">
                    <v-col cols="auto">
                      <v-spacer></v-spacer>
                      <v-img height="200" width="200" :src="item.img" />
                    </v-col>
                    <!-- <v-col cols="auto" class="text-center pl-0" >
                      <v-row class="flex-column" justify="center">
                        <v-col class="px-0">
                          <v-btn icon>
                            <v-icon @click="item.frm = true">mdi-cogs</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col class="px-0">
                          <v-btn icon>
                            <v-icon @click="removeCam(index)" color="error"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col> -->
                  </v-row>
                  <FrmCam
                    :openFrm="item.frm"
                    :content="item"
                    :idx="index"
                    @close="item.frm = false"
                    @addCam="addCam"
                    :key="index"
                  />
                </v-card-text>
              </v-card>
            </v-row>
            <v-col cols="12" md="8">
              <v-alert
                border="left"
                colored-border
                elevation="1"
                color="color_alert"
                dense
                class="rounded-lg mb-4 col-12"
                :style="{
                  border: '1px solid #e0004d',
                  'border-radius': '20px',
                }"
              >
                <div class="py-2">
                  <p class="font-weight-light my-0 text-body-2">
                    Selecione as câmeras que você gostaria de monitorar
                  </p>
                </div>
              </v-alert>
            </v-col>
            <v-spacer />
            <v-btn
              color="verde"
              dark
              class="font-weight-light"
              :disabled="disabledSalvarCamera || this.listaCamSelecionada.length<=0"
              @click="nextStep(6)"
              >Continue</v-btn
            >
            <v-btn
              color="error"
              :disabled="progressFindCam"
              class="ml-2"
              @click="nextStep(4)"
              >Voltar</v-btn
            >
          </v-stepper-content>
          <v-stepper-step
            :complete="step > 6"
            :color="step > 6 ? 'verde' : 'primary'"
            step="6"
          >
            Notificação
            <small>Configuração de notificação Telegram</small>
          </v-stepper-step>

          <v-stepper-content step="6">
            <Notification
              @next="salvarCamera"
              @cancel="nextStep(5)"
              :btnCancel="true"
              maxWidth="100%"
            />
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { uuidv4, isDataURL } from "../../services/utils";
import Notification from "../minha-conta/Notification.vue";
import FrmCam from "./FrmCam";
export default {
  components: { FrmCam, Notification },
  name: "Scan",
  data() {
    return {
      event: null,
      step: 0,
      titulo: "Cadastro de câmeras",
      windowScan: false,
      listaCamSelecionada: [],
      idMsg: "",
      //
      user: null,
      pwd: null,
      listModelos: [
        { header: "INTELBRAS" },
        {
          label: "INTELBRAS",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/cam/realmonitor?channel=[channel]&subtype=0",
        },
        {
          label: "INTELBRAS",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp?",
        },
        //
        { header: "LUXVISION" },
        {
          label: "LUXVISION",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "DVR/NVR – Linha TW – Tecvoz" },
        {
          label: "DVR/NVR – Linha TW – Tecvoz",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/chID=[channel]&streamType=main&linkType=tcpa",
        },
        //
        { header: "DVR/NVR – Linha T1/THK – Tecvoz" },
        {
          label: "DVR/NVR – Linha T1/THK – Tecvoz",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/Streaming/Channels/0[channel]",
        },
        //
        { header: "DVR – TVZ" },
        {
          label: "DVR – TVZ",
          url: "rtsp://[ip]:[port]/user=[user]&password=[´wd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "Linha ICB Inteligente – Tecvoz" },
        {
          label: "Linha ICB Inteligente – Tecvoz",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/mode=real&idc=[channel]&ids=1",
        },
        //
        { header: "ALIVE" },
        {
          label: "ALIVE",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp?real_stream",
        },
        //
        { header: "CLEAR" },
        {
          label: "CLEAR",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "DAHUA" },
        {
          label: "DAHUA",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp?",
        },
        //
        { header: "GREATEK" },
        {
          label: "GREATEK",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "GIGA" },
        {
          label: "GIGA",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "HDL" },
        {
          label: "HDL",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "HIKVISION" },
        {
          label: "HIKVISION",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/h264/ch[channel]/main/av_stream",
        },
        //
        { header: "JFL" },
        {
          label: "JFL",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/h264/ch[channel]/main/av_stream",
        },
        //
        { header: "JORTAN" },
        {
          label: "JORTAN",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp",
        },
        //
        { header: "MULTILASER" },
        {
          label: "MULTILASER",
          url: "rtsp://[user]:[pwd]@[ip]:[port]/H264?ch=[channel]&subtype=0",
        },
        //
        { header: "VENETIAN" },
        {
          label: "VENETIAN",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp?",
        },
        {
          label: "VENETIAN",
          url: "rtsp://[user~]:[pwd]@[ip]:[port]/cam/realmonitor?channel=[channel]&subtype=0&unicast=true&proto=Onvif",
        },
        //
        { header: "TWG" },
        {
          label: "TWG",
          url: "rtsp://[ip]:[port]/user=[user]&password=[pwd]&channel=[channel]&stream=0.sdp?",
        },
      ],
      selectModeloUrl: null,
      //
      ipDigitadoError:'',
      ipDigitado:'',
      nextStepIp:1,
      redeSelecionada: [],
      headersRedes: [
        { text: "Sub-net", value: "subnet", sortable: false },
        { text: "Mask", value: "mask", sortable: false },
        // { text: "Ações", value: "actions", sortable: false }
      ],
      textLoadRede: "Aguarde, procurando rede",
      gridLoadRede: false,
      listRedes: [],
      //
      cam_port: 554,
      cam_url: "",
      openEditUrlCamera: false,
      headersLogins: [
        { text: "Usuario", value: "user", sortable: false },
        { text: "Senha", value: "pwd", sortable: false },
        { text: "Ações", value: "actions", sortable: false },
      ],
      listaLogins: [],
      url: "rtsp://[user]:[pwd]@[ip]:[port]/cam/realmonitor?channel=[channel]&subtype=0",
      //
      progressFindCam: true,
      disabledSalvarCamera: true,
      error_equipamento: "",
      listCams: [],
      listEventos: [],
    };
  },
  computed: {
    urlCamera: {
      set(value) {
        this.cam_url = value;
      },
      get() {
        // let url = `rtsp://${this.cam_user}:${this.cam_pwd}@${this.cam_ip}:${this.cam_port}/cam/realmonitor?channel=[channel]&subtype=0`;
        return this.cam_url;
      },
    },
  },
  props: ["openFrmScan", "limitCam", "listCamExist"],
  watch: {
    ipDigitado(){
      this.validIpDigitado()
    },
    selectModeloUrl(value) {
      this.urlCamera = value;
    },
    openFrmScan(value) {
      this.windowScan = value;
      this.step=0;
      this.nextStepIp = 1
      this.ipDigitado = ''
      this.ipDigitadoError = ''
    },
    windowScan(value) {
      if (!value) {
        this.clearData();
        this.$emit("close");
        this.step = 1;
      }

    },
  },
  created() {
    this.$root.clearHashTable();
    this.$root.abortFindMessageServer();
  },
  methods: {
    validIpDigitado(){
      let erro = ''
      let test = this.ipDigitado.split('.')
      this.nextStepIp = 1
      if(test.length==4) {
          test.forEach(val=>{
            if(val.length>3 || val.length<=0) {
                erro = 'Verifique se IP digitado está correto.'
            }
          })
          this.nextStepIp = 2
          this.redeSelecionada = [{subnet:33,mask:this.ipDigitado}]
      }else{
        erro = 'Verifique se IP digitado está correto.'
      }

      this.ipDigitadoError = erro
    },
    removeCam(idx) {
      let copy = [...this.listCams];
      copy.splice(idx, 1);
      this.listCams = copy;
    },
    addCam(obj) {
      this.anyEdit = true;
      obj.cfg.frm = false;
      let copy = [...this.listCams];
      copy.splice(obj.idx, 1);
      this.listCams = copy;
      this.listCams.push(Object.assign({}, obj.cfg));
    },
    salvarCamera() {
      let msg = "";
      if (this.listaCamSelecionada.length <= 0) {
        msg = "Nenhuma câmera foi configurada!";
      }
      if (this.listaCamSelecionada.length > this.limitCam) {
        msg = "Limite de " + this.limitCam + " câmeras atingido!";
      }
      if (msg.length > 0) {
        this.$store.dispatch("setMsgError", msg);
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      let listCams = [];
      //
      this.listaCamSelecionada.forEach(value =>{
        if(typeof this.listCams[value] != 'undefined') {
          listCams.push({...this.listCams[value]})
        }
      })
      //remove prefix content
      listCams.forEach((value, index) => {
        let split = value.img.split(",");
        if (Array.isArray(split) && split.length > 1) {
          listCams[index].img = split[1];
        }
      });
      if(listCams.length<=0) {
          this.$store.dispatch("setMsgError", 'Nenhuma câmera foi selecionada!');
          this.$store.dispatch("setDisplayMsgErr", true);
          return 
      }
      //
      let event_name = "operation-30";
      this.listEventos.push(event_name);
      this.$store.dispatch("displayLoading", true);
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: { operation: 30, data: listCams },
        },
        false,
        (res) => {
          if (res.data.message == "ok") {
            this.anyEdit = false;
            this.$store.dispatch("displayLoading", true);
          }
        }
      );
      this.$root.$on(event_name, () => {
        this.$store.dispatch("displayLoading", false);
        this.$store.dispatch("MsgSucces", "Operação realizada com sucesso!");
        this.$store.dispatch("displayMsgSuccess", true);
        this.closeWindowScan();
      });
    },
    stopMonitoramento(){
      let event_name = "operation-90";
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: {
            operation: 90,
            data: "stop" 
          },
        },
        false,
        (res) => {
          if (res.data.message == "ok") {
            this.$store.dispatch("setStatusCams", null);
            this.startMonitoramento()
          } else {
            this.$store.dispatch(
              "setMsgError",
              "Não foi possível Parar monitoramento!"
            );
            this.stopMonitoramento();
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        }
      );
      this.$root.$on(event_name, (obj) => {
        this.$store.dispatch("setListStatusCams", [...obj.result.cameras]);
        this.displayChangeStatus = false;
      });
    },
    startMonitoramento(){
      let event_name = "operation-90";
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: {
            operation: 90,
            data: "start",
          },
        },
        false,
        (res) => {
          if (res.data.message == "ok") {
            this.$store.dispatch("setStatusCams", null);
          } else {
            this.$store.dispatch(
              "setMsgError",
              "Não foi possível Iniciar monitoramento!"
            );
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        }
      );
      this.$root.$on(event_name, (obj) => {
        this.$store.dispatch("setListStatusCams", [...obj.result.cameras]);
        this.displayChangeStatus = false;
      });
    },
    clearData() {
      this.listRedes = [];
      this.listaLogins = [];
      this.redeSelecionada = [];
      this.cam_port = 554;
      this.$root.$off(this.listEventos);
      this.$root.clearHashTable();
    },
    addUser() {
      if (this.user.length <= 0 || this.pwd.length <= 0) {
        return false;
      }
      let content = {
        user: this.user,
        pwd: this.pwd,
      };
      this.listaLogins.push(content);
      //
      this.user = null;
      this.pwd = null;
    },
    removeRede(idx) {
      let copy = [...this.listRedes];
      copy.splice(idx, 1);
      this.listRedes = copy;
    },
    removeUser(idx) {
      let copy = [...this.listaLogins];
      copy.splice(idx, 1);
      this.listaLogins = copy;
    },
    closeWindowScan() {
      this.$emit("close", "");
      this.$emit("eventScan", { event: "abort" });
    },
    nextStep(step) {
      switch (step) {
        case 1:
          this.buscarRede();
          break;
        case 2:
          if (this.redeSelecionada.length <= 0) {
            this.$store.dispatch("setMsgError", "Selecione ao menos uma rede");
            this.$store.dispatch("setDisplayMsgErr", true);
            return;
          }
          break;
        case 5:
            this.listCams = [];
            this.progressFindCam = true;
            this.buscarCam();
          break;
        case 6:
          this.$emit("reloadNotification");
          break;
      }
      this.$root.resetTemporizadorUser();
      this.step = step;
    },
    getDate() {
      let datetime = new Date();
      let split = datetime.toISOString().split("T");
      return split[0] + " " + split[1].split(".")[0];
    },
    uuid() {
      return uuidv4();
    },
    buscarCam() {
      //
      let rede = { ...this.redeSelecionada[0] };
      delete rede.id;
      let content = {
        net: rede,
        login: this.listaLogins,
        url: window.btoa(this.urlCamera),
        port: this.cam_port,
      };
      this.progressFindCam = true;
      this.error_equipamento = "";
      //
      let event_name = "operation-20";
      this.listEventos.push(event_name);
      this.$store.dispatch("displayLoading", true);
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: { operation: 20, data: content },
        },
        false
      );
      this.$root.$on(event_name, (obj) => {
        this.$store.dispatch("displayLoading", false);
        if (obj.success != true) {
          this.progressFindCam = false;
          this.error_equipamento =
            "Ops, algo deu errado volte e verifique as informações que foram preenchidas!";
          return;
        }
        this.listCams = [];
        // if (this.listCamExist.length > 0) {
        //   this.listCams = [...this.listCamExist];
        // }

        obj.result.forEach((item) => {
          if (!isDataURL(item.img)) {
            item.img = "data:image/jpeg;base64," + item.img;
          }
          item.url = item.url ? item.url : "";
          item.cam = item.cam ? item.cam : "";
          item.frm = false;
          item.ver = { x: [], y: [], w_x: [], w_y: [] };
          item.cfg = {
            Sunday: [{ start: 0, end: 24 }],
            Monday: [{ start: 0, end: 24 }],
            Tuesday: [{ start: 0, end: 24 }],
            Wednesday: [{ start: 0, end: 24 }],
            Thursday: [{ start: 0, end: 24 }],
            Friday: [{ start: 0, end: 24 }],
            Saturday: [{ start: 0, end: 24 }],
            Specific: [],
          };
          this.listCams.push(item);
        });
        this.progressFindCam = false;
        this.disabledSalvarCamera = false;
      });
    },
    buscarRede() {
      this.gridLoadRede = true;
      let event_name = "operation-10";
      this.listEventos.push(event_name);
      this.$store.dispatch("displayLoading", true);
      this.$root.createMessageServer(
        event_name,
        {
          hostId: this.$store.getters.hostActive,
          channel: 1,
          msgId: this.uuid(),
          datetime: this.getDate(),
          value: { operation: 10 },
        },
        false
      );
      this.$root.$on(event_name, (obj) => {
        this.$store.dispatch("displayLoading", false);
        this.listRedes = [];
        obj.result.forEach((item) => {
          item.id = this.uuid();
          this.listRedes.push(item);
        });
        this.gridLoadRede = false;
      });
    },
  },
  destroyed() {
    this.$root.clearHashTable();
    this.$root.abortFindMessageServer();
  },
};
</script>